import { models, IDispatch, IState } from "./../modules/index";
import { init } from "@rematch/core";

const store = init({
  models
});

export const Dispatch: IDispatch = store.dispatch as any;

export const getState: () => IState = store.getState as any;

export default store;



// WEBPACK FOOTER //
// ./src/state/store/store.ts